import { OnInit, Component, ElementRef, Input, ViewChild, forwardRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Stepper from 'bs-stepper';
import { Observable, Subject, Subscription, debounceTime, distinctUntilChanged, first, map, startWith } from 'rxjs';
import { Locality } from 'src/app/core/models';
import { FilterCriteria } from 'src/app/core/models/filter.criteria.model';
import { BienService } from 'src/app/core/services/bien.service';
import { FilterService } from 'src/app/core/services/filter.service';
import { CheckboxGroupComponent } from 'src/app/modules/biens/components/checkbox-group/checkbox-group.component';

@Component({
  selector: 'app-modal-estimation-rdv',
  templateUrl: './modal-estimation-rdv.component.html',
  styleUrls: ['./modal-estimation-rdv.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true
    }
  ]
})
export class ModalEstimationRdvComponent implements OnInit {
  @Input() filterCriterias: FilterCriteria = {};
  @Input() localityInput: any = {};
  closeResult?: string;
  private stepper?: Stepper;

  typeBienChoosed : any;
  stepFormulaireHover = '';
  stepIndex = 0;

  searchForm!: FormGroup;

  defaultTypes: any;
  defaultPieces: any;

  filtersNbPiece: any = [];

  filtersNbRoom: any = [];
  defaultRooms: any;

  nbPieceUpdate = new Subject<[]>();
  nbRoomUpdate = new Subject<[]>();

  subjectForm = [
    { id: 'maison', text: 'Une maison' },
    { id: 'appartement', text: 'Un appartement' },
    { id: 'terrain', text: 'Un terrain' },
    { id: 'local_commercial', text: 'Un local commercial' },
  ];
  disponibilityTextArray = [
    "Le matin", "L’après-midi", "Peu importe"
  ];
  constructor(
    private filterService: FilterService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private bienService: BienService
  ) {
    this.createSearchForm();
    this.beginSearch();
  }

  ngOnInit() {
    this.loadFiltersFormData();
  }

  inputStream$: Subscription = new Subscription;
  searchedAddresses: Locality[] = [];
  inputChange$!: Observable<string>;
  choosedLocality?: Locality | null;
  actionFromChoosedLocality?: boolean = false;
  submitted = false;
  @ViewChild('locality') locality!: ElementRef<HTMLElement>;




  // convenience getter for easy access to form fields
  get f() { return this.searchForm.controls; }


  beginSearch(): void {
    if (this.searchForm) {
      this.inputChange$ = this.searchForm.controls.locality.valueChanges
      this.searchedAddresses = [];
      this.inputStream$ = this.inputChange$
        .pipe(
          map((e: string) => e),
          debounceTime(400),
          distinctUntilChanged(),
          startWith(''),
        )
        .subscribe(c => {
          if (!this.actionFromChoosedLocality) {
            this.choosedLocality = null;
            if (this.searchForm.controls.locality.value) {
              this.filterService.searchBackendLocalities(this.searchForm.controls.locality.value, '/google').pipe(first()).subscribe((response:any) => {
                this.searchedAddresses = response.data;
              });
            } else {
              this.searchedAddresses = [];
            }
          } else {
            this.actionFromChoosedLocality = false;
          }

        });
    }

  }

  chooseLocality(item: Locality) {
    this.actionFromChoosedLocality = true
    this.choosedLocality = item;
    this.searchForm.patchValue({
      locality: this.textLocality(item)
    });
    this.searchedAddresses = [];
  }

  textLocality(item: Locality) {
    let localityText = item.ville
    return localityText;
  }

  cancelSearchingAddress() {
    this.searchedAddresses = [];
  }

  next() {
    // validate the address
    if (this.stepIndex == 0) {
      this.validateAddress();
    } else if (this.stepIndex == 2) {
      this.validateSurface();
    } else if (this.stepIndex == 3) {
      this.validateCoordonnees();
    } else {
      this.stepper?.next();
    }
  }

  previous() {
    this.stepper?.previous();
  }

  onSubmit() {
    return false;
  }

  validateAddress() {
    this.submitted = true;
    if (!this.choosedLocality) {
      this.searchForm.patchValue({
        locality: ''
      });
      return;
    }
    this.submitted = false;
    this.stepper?.next();
  }

  validateSurface() {
    this.submitted = true;
    if (this.searchForm.controls.surface.errors?.required) {
      return;
    }
    this.submitted = false;
    this.stepper?.next();
  }


  validateCoordonnees() {
    this.submitted = true;
    if (
      this.searchForm.controls.firstName.errors?.required 
      || this.searchForm.controls.lastName.errors?.required 
      || this.searchForm.controls.email.errors?.required 
      || this.searchForm.controls.phone.errors?.required 
      || this.searchForm.controls.email.errors?.pattern 
      || this.searchForm.controls.phone.errors?.pattern 
      || this.searchForm.controls.disponibility.errors?.required 
      ) {
      return;
    }
    this.submitted = false;
    let data = this.searchForm.value
    data.type_property = this.typeBienChoosed
    data.nb_room = data.nb_room ? data.nb_room[0] : '' // to delete after ( checkbox -> radio)
    data.nb_piece = data.nb_piece ? data.nb_piece[0] : '' // to delete after ( checkbox -> radio)
    this.bienService.requestRdvEstimation(data).pipe(first()).subscribe(response => {
      this.stepper?.next();
    });
    
  }

  setSubject(item: any) {
    this.typeBienChoosed = item;
    this.stepper?.next();
  }

  openFullscreen(content: any) {
    this.modalService.open(content, { fullscreen: true });
    this.createStepper()
    if (this.localityInput?.ville) {
      this.choosedLocality = this.localityInput
      this.actionFromChoosedLocality = true
      this.searchForm.patchValue({
        locality: this.localityInput?.ville
      });
      setTimeout(() => {
        this.stepper?.next();
      }, 10);
    }
  }

  createStepper() {
    setTimeout(() => {
      const portalDiv = document.querySelector('#stepper1')!;
      this.stepper = new Stepper(portalDiv, {
        linear: false,
        animation: true,
      });
      portalDiv.addEventListener('show.bs-stepper', (event: any) => {
        this.stepIndex = event.detail.indexStep;
      });
    }, 0);
  }

  feedFormElements() {
    this.filtersNbPiece = this.filterService.fetchNbPiece(this.filterFormData);
    this.filtersNbRoom = this.filterService.fetchNbRoom(this.filterFormData);
  }
  filterFormData(filterFormData: any): any {
    throw new Error('Method not implemented.');
  }

  createSearchForm() {
    this.searchForm = this.formBuilder.group({
      locality: ['', Validators.required],
      nb_piece: new FormControl(null),
      nb_room: [''],
      surface: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10})$/)])],
      email: [null, Validators.compose([Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)])],
      disponibility: ['', Validators.required],
      terms: ['', Validators.required]
    });
  }

  loadFiltersFormData() {
    this.filterService
      .loadFiltersFormData()
      .pipe(first())
      .subscribe((response:any) => {
        this.filterFormData = response.data;
        this.feedFormElements();
      });
  }

  chooseNbPiece() {
    this.filterCriterias.nb_piece = this.searchForm.value.nb_piece;
  }
  chooseNbRoom() {
    this.filterCriterias.nb_room = this.searchForm.value.nb_room;
  }
}
